module.exports = __webpack_public_path__ + "static/media/10H.012a3243.svg";